export function customAudio() {
  /*  document.addEventListener("DOMContentLoaded", function () {
        const audioBlocks = document.querySelectorAll(".audio-block");

        // Array to store all audio elements
        const allAudioElements = [];

        audioBlocks.forEach((block, index) => {
            const audio = block.querySelector("audio");
            const audioPlayer = block.querySelector(".audio-player");

            // Checking for the presence of audio and audio-player elements
            if (!audio || !audioPlayer) {
                console.warn(`Audio or audio-player element is missing in block #${index + 1}. Skipping this block.`);
                return;
            }

            const playBtn = audioPlayer.querySelector(".controls .toggle-play");
            const timeline = audioPlayer.querySelector(".timeline");
            const progressBar = audioPlayer.querySelector(".progress");
            const currentTimeElement = audioPlayer.querySelector(".time .current");
            const lengthTimeElement = audioPlayer.querySelector(".time .length");

            if (!audio || !playBtn || !timeline || !progressBar || !currentTimeElement || !lengthTimeElement) {
                console.error("One or more elements are missing in the audio player block.");
                return;
            }

            // Adding an audio element to the array
            allAudioElements.push(audio);

            audio.addEventListener("loadeddata", function () {
                lengthTimeElement.textContent = getTimeCodeFromNum(audio.duration);
                audio.volume = 0.75;
            }, false);

            audio.addEventListener("ended", function () {
                playBtn.classList.remove("pause");
            });

            timeline.addEventListener("click", function (e) {
                const timelineWidth = parseInt(window.getComputedStyle(timeline).width);
                const timeToSeek = e.offsetX / timelineWidth * audio.duration;
                audio.currentTime = timeToSeek;
            }, false);

            setInterval(function () {
                progressBar.style.width = audio.currentTime / audio.duration * 100 + "%";
                currentTimeElement.textContent = getTimeCodeFromNum(audio.currentTime);
            }, 500);

            playBtn.addEventListener("click", function () {
                if (audio.paused) {
                    // Stop all other audio
                    allAudioElements.forEach(a => {
                        if (a !== audio) {
                            a.pause();
                            const otherPlayBtn = a.closest(".audio-block").querySelector(".controls .toggle-play");
                            otherPlayBtn.classList.remove("pause");
                        }
                    });

                    playBtn.classList.add("pause");
                    audio.play();
                } else {
                    playBtn.classList.remove("pause");
                    audio.pause();
                }
            }, false);
        });

        function getTimeCodeFromNum(num) {
            let seconds = parseInt(num);
            let minutes = parseInt(seconds / 60);
            seconds = seconds % 60;
            const hours = parseInt(minutes / 60);
            minutes = minutes % 60;

            if (hours > 0) {
                return `${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
            } else {
                return `${minutes}:${String(seconds).padStart(2, '0')}`;
            }
        }
    }); */

    document.addEventListener("DOMContentLoaded", function () {
        const audioBlocks = document.querySelectorAll(".audio-block");
        const allAudioElements = [];

        audioBlocks.forEach((block, index) => {
            const audio = block.querySelector("audio");
            const audioPlayer = block.querySelector(".audio-player");

            if (!audio || !audioPlayer) {
                console.warn(`Audio or audio-player element is missing in block #${index + 1}. Skipping this block.`);
                return;
            }

            const playBtn = audioPlayer.querySelector(".controls .toggle-play");
            const timeline = audioPlayer.querySelector(".timeline");
            const progressSvg = timeline.querySelector(".progress-svg");
            const rects = progressSvg.querySelectorAll(".bar");
            const currentTimeElement = audioPlayer.querySelector(".time .current");
            const lengthTimeElement = audioPlayer.querySelector(".time .length");

            if (!playBtn || !timeline || !progressSvg || !currentTimeElement || !lengthTimeElement) {
                console.error("One or more elements are missing in the audio player block.");
                return;
            }

            allAudioElements.push(audio);

            audio.addEventListener("loadedmetadata", function () {
                lengthTimeElement.textContent = getTimeCodeFromNum(audio.duration);
                audio.volume = 0.75;
            }, false);

            audio.addEventListener("ended", function () {
                playBtn.classList.remove("pause");
            });

            timeline.addEventListener("click", function (e) {
                const timelineRect = timeline.getBoundingClientRect();
                const offsetX = e.clientX - timelineRect.left;
                const timelineWidth = timelineRect.width;
                const timeToSeek = (offsetX / timelineWidth) * audio.duration;

                console.log(`Timeline clicked: OffsetX = ${offsetX}, TimelineWidth = ${timelineWidth}, TimeToSeek = ${timeToSeek}`);

                audio.currentTime = Math.min(Math.max(timeToSeek, 0), audio.duration);
                console.log(`Seek to: ${audio.currentTime}`);

                // Обновление прогресс-бара после seek
                updateProgressBar();
            }, false);

            audio.addEventListener("timeupdate", function () {
                updateProgressBar();
            });

            audio.addEventListener("seeked", function () {
                updateProgressBar();
            });

            function updateProgressBar() {
                if (audio.duration === 0) return; // Защита от деления на ноль

                const progress = audio.currentTime / audio.duration;
                const totalBars = rects.length;
                const barsToFill = Math.floor(progress * totalBars); // Используем floor для округления вниз

                console.log(`Updating progress bar: Current Time = ${audio.currentTime}, Duration = ${audio.duration}, Progress = ${progress}`);
                console.log(`Total Bars = ${totalBars}, Bars to Fill = ${barsToFill}`);

                rects.forEach((rect, i) => {
                    rect.style.fill = i < barsToFill ? "red" : "#c5c5c5";
                });

                currentTimeElement.textContent = getTimeCodeFromNum(audio.currentTime);
                lengthTimeElement.textContent = getTimeCodeFromNum(audio.duration);
            }

            playBtn.addEventListener("click", function () {
                if (audio.paused) {
                    allAudioElements.forEach(a => {
                        if (a !== audio) {
                            a.pause();
                            const otherPlayBtn = a.closest(".audio-block").querySelector(".controls .toggle-play");
                            otherPlayBtn.classList.remove("pause");
                        }
                    });

                    playBtn.classList.add("pause");
                    audio.play();
                } else {
                    playBtn.classList.remove("pause");
                    audio.pause();
                }
            }, false);
        });

        function getTimeCodeFromNum(num) {
            let seconds = Math.floor(num);
            let minutes = Math.floor(seconds / 60);
            seconds = seconds % 60;
            const hours = Math.floor(minutes / 60);
            minutes = minutes % 60;

            if (hours > 0) {
                return `${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
            } else {
                return `${minutes}:${String(seconds).padStart(2, '0')}`;
            }
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/customAudio.js